import Alpine from 'alpinejs';
import { Breakpoints } from "../breakpoints.js";
import { slideDown, slideToggle, slideUp, slideToggleDefaults } from './snippets/slide-toggle-container.js';

window.setSectionTabindex = (el, to = "-1") => {
  [...(el instanceof NodeList
    ? el
    : el.querySelectorAll('a, input, button'))
    ].forEach((item) => {
    item.setAttribute("tabindex", to);
  });
};

window.slideToggle = (el, opts = {}) => {
  slideToggle(el, { ...slideToggleDefaults, ...opts });
};
window.slideUp = (el, opts = {}) => {
  slideUp(el, { ...slideToggleDefaults, ...opts });
};;
window.slideDown = (el, opts = {}) => {
  slideDown(el, { ...slideToggleDefaults, ...opts });
};
window.createFocusTrap = (el, opts = {}) => createFocusTrap(el, opts);

window.Breakpoints = Breakpoints;

window.Alpine = Alpine;
